import { render, staticRenderFns } from "./addAdmin.vue?vue&type=template&id=3a35826d&scoped=true"
import script from "./addAdmin.vue?vue&type=script&lang=js"
export * from "./addAdmin.vue?vue&type=script&lang=js"
import style0 from "./addAdmin.vue?vue&type=style&index=0&id=3a35826d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a35826d",
  null
  
)

export default component.exports